    <mat-form-field class="date-picker" >
      <input matInput [matDatepicker]="picker" placeholder="Choose a date" [(ngModel)]="modelDate"
        (dateChange)="onDateSelected($event)" (blur)="setManualDate()" dateInput="onDateSelected($event)" [disabled]="isDisabled" >
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker ></mat-datepicker>
    </mat-form-field>
